module.exports = __webpack_public_path__ + "static/img/CL@2x.55793edb.jpg";